histories-orders-phase-updated
  span.event {this.locale().event}
  span.updated
    histories-updated-reverse.description(if="{opts.json.description != undefined}" tag-scope="{this.tagScope}" scope="description" locale="{locale()}" getter="{straight}" label="（{this.phaseName()}）" label-style="background: {this.phaseColorCode()};")
  script(type="typescript").
    this.mixin('histories.base');
